import { ValueNode } from './ValueNode';
export class AnnotationNode extends ValueNode {
    value;
    attributes;
    constructor(id, value, key, metadata, attributes = []) {
        super(id, key, metadata);
        this.value = value;
        this.attributes = attributes;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub3RhdGlvbk5vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL3R5cGVzL3JlY29yZC9Bbm5vdGF0aW9uTm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBS3ZDLE1BQU0sT0FBTyxjQUVYLFNBQVEsU0FBUztJQUNqQixLQUFLLENBQVE7SUFDYixVQUFVLENBQWtCO0lBRTVCLFlBQ0UsRUFBVSxFQUNWLEtBQWEsRUFDYixHQUFZLEVBQ1osUUFBbUIsRUFDbkIsYUFBK0IsRUFBRTtRQUVqQyxLQUFLLENBQUMsRUFBRSxFQUFFLEdBQUcsRUFBRSxRQUFRLENBQUMsQ0FBQTtRQUN4QixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsQ0FBQTtJQUM5QixDQUFDO0NBQ0YifQ==